/* Assets */
import "./publicProfile.css";
import "react-photoswipe/lib/photoswipe.css";

/* Constants */
import * as routes from "../constants/routes";

import React, { Component } from "react";

import Api from "../services/api";
/* Services/Helpers */
import AuthService from "../services/auth";
import FullWidthInfo from "../components/FullWidthInfo";
// import GoogleAd from "react-google-ad";
import Modal from "react-modal";
import { PhotoSwipe } from "react-photoswipe";
import Select from "react-select";
/* Components */
import Slider from "../components/slider";
import USER_STATUSES from "../constants/userStatuses";
import chevron from "../static/vectors/chevron.svg";
import clock from "../static/vectors/clock.svg";
import { compose } from "recompose";
import { connect } from "react-redux";
import { db } from "../firebase";
import diamond from "../static/vectors/gem-black.svg";
import { fullCountryName } from "../helpers/functions";
import heartSolid from "../static/vectors/heart-solid.svg";
import heartSolidRed from "../static/vectors/heart-solid-red.svg";
import location from "../static/vectors/location-arrow.svg";
import logo from "../static/images/upperclass-icon-only.png";
import mask from "../static/images/host-icon.png";
import message from "../static/vectors/message.svg";
import moment from "moment";
import star from "../static/vectors/star.svg";
import userIcon from "../static/vectors/user.svg";
import withAuthorization from "../components/withAuthorization";

class publicProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successReport: false,
      reportMessage: "",
      isModalOpen: false,
      galleryModalOpen: false,
      modalInitialPhoto: 0,
      slug: this.props.match.params.slug,
      showUserSubMenu: false,
      user: {
        photos: [],
        locations: []
      },
      educationLabels: {
        highSchool: "High School",
        bachelor: "Bachelor",
        master: "Master"
      },
      ethnicityLabels: {
        asian: "Asian",
        african: "African",
        caucasian: "Caucasian",
        middle_eastern: "Middle Eastern",
        latin: "Latin"
      },
      bodyTypeLabels: {
        slim: "Slim",
        athletic: "Athletic",
        curvy: "Curvy"
      },
      relationshipLabels: {
        single: "Single",
        openRelationship: "Open Relationship"
      },
      lookingForLabels: {
        sugar_parent_m: "Sugar Daddy",
        sugar_parent_f: "Sugar Mama",
        sugar_baby_m: "Sugar Baby (Male)",
        sugar_baby_f: "Sugar Baby (Female)",
        sugar_parent_a: "Sugar Daddy or Mama",
        sugar_baby_a: "Sugar Baby"
      },
      lifestyleExpectationLabels: {
        negotiable: "Negotiable",
        moderate: "Moderate",
        high: "High"
      }
    };
  }

  componentWillReceiveProps(newProps) {
    const { slug } = this.state;
    const { ucdUser } = this.props;
    if (slug !== newProps.match.params.slug) {
      new Api()
        .get(
          `/users/${newProps.match.params.slug}`,
          {},
          AuthService.getAuthCookie()
        )
        .then(response => {
          if (
            (response.user.status < USER_STATUSES.approved &&
              response.user.id !== ucdUser.id) ||
            ucdUser.isBlockedBy.includes(response.user.id)
          ) {
            this.props.history.push(routes.HOME);
          } else {
            response.user.photos.map((photo, i) => {
              if (photo.src.length === 0) {
                response.user.photos[i].src = photo.thumbnail;
                response.user.photos[i].w = 1200;
                response.user.photos[i].h = 1200;
              }
              return photo;
            });
            this.setState({
              slug: newProps.match.params.slug,
              user: response.user
            });
          }
        });
    }
  }

  componentDidMount() {
    const { slug } = this.state;
    const { ucdUser } = this.props;

    new Api()
      .get(`/users/${slug}`, {}, AuthService.getAuthCookie())
      .then(response => {
        if (
          (response.user.status < USER_STATUSES.approved &&
            response.user.id !== ucdUser.id) ||
          ucdUser.isBlockedBy.includes(response.user.id)
        ) {
          this.props.history.push(routes.HOME);
        } else {
          response.user.photos.map((photo, i) => {
            if (photo.src.length === 0) {
              response.user.photos[i].src = photo.thumbnail;
              response.user.photos[i].w = 1200;
              response.user.photos[i].h = 1200;
            }
            return photo;
          });
          this.setState({
            user: response.user
          });
        }
      })
      .catch(() => {
        this.props.history.push(routes.HOME);
      });
  }

  fakeLastActiveDate(user) {
    let fake = moment().subtract(Math.floor(Math.random() * 5) + 1, "days");
    let createdAt = moment(user.created_at);
    if (fake.isBefore(createdAt)) {
      return createdAt.format("MMM D, YYYY");
    } else {
      return fake.format("MMM D, YYYY");
    }
  }

  createRoom(id) {
    const { ucdUser, onChatRoomSelected } = this.props;
    const { user } = this.state;
    let createRoom = true;
    let roomId = "";
    db.listUsersRoom(ucdUser.id)
      .once("value")
      .then(snapshot => {
        let rooms = snapshot.val();

        if (rooms !== null) {
          Object.keys(rooms).map(roomKey => {
            if (rooms[roomKey].members.includes(id)) {
              createRoom = false;
              roomId = roomKey;
            }
            return roomKey;
          });
        }
        if (createRoom) {
          const roomKey = db.doCreateRoom(ucdUser.id, id);
          onChatRoomSelected(roomKey, user);
        } else {
          onChatRoomSelected(roomId, user);
        }
      });
  }

  handleGalleryModalOpen(modalInitialPhoto, e = false) {
    if (!e) {
      this.setState({ galleryModalOpen: true, modalInitialPhoto });
    } else {
      if (window.innerWidth < 768) {
        this.setState({ galleryModalOpen: true, modalInitialPhoto });
      }
    }
  }

  submitReport() {
    const { user, reason, reasonText } = this.state;
    const { ucdUser } = this.props;
    new Api()
      .post(
        "/users/report",
        { target: user.id, creator: ucdUser.id, reason, text: reasonText },
        AuthService.getAuthCookie()
      )
      .then(response => {
        if (response.success) {
          this.setState({
            successReport: true,
            reportMessage: response.message
          });
        }
      });
  }

  toggleFavourite(user, value) {
    const { authUser, onSetAuthUser } = this.props;
    if (value) {
      new Api()
        .post("/favourites", { targetId: user }, AuthService.getAuthCookie())
        .then(() => {
          new Api()
            .get("/users/current", {}, AuthService.getAuthCookie())
            .then(response => {
              onSetAuthUser(authUser, response.user);
            });
        });
    } else {
      new Api()
        .remove("/favourites", { targetId: user }, AuthService.getAuthCookie())
        .then(() => {
          new Api()
            .get("/users/current", {}, AuthService.getAuthCookie())
            .then(response => {
              onSetAuthUser(authUser, response.user);
            });
        });
    }
  }

  toggleBlock(user, value) {
    const { authUser, onSetAuthUser } = this.props;
    if (value) {
      new Api()
        .post("/blocks", { targetId: user }, AuthService.getAuthCookie())
        .then(() => {
          new Api()
            .get("/users/current", {}, AuthService.getAuthCookie())
            .then(response => {
              onSetAuthUser(authUser, response.user);
              this.setState({
                showUserSubMenu: false
              });
            });
        });
    } else {
      new Api()
        .remove("/blocks", { targetId: user }, AuthService.getAuthCookie())
        .then(() => {
          new Api()
            .get("/users/current", {}, AuthService.getAuthCookie())
            .then(response => {
              onSetAuthUser(authUser, response.user);
              this.setState({
                showUserSubMenu: false
              });
            });
        });
    }
  }

  toggleUserPopup() {
    const { showUserSubMenu } = this.state;
    this.setState({
      showUserSubMenu: !showUserSubMenu
    });
  }

  render() {
    const {
      user,
      showUserSubMenu,
      isModalOpen,
      reason,
      successReport,
      reportMessage,
      galleryModalOpen,
      modalInitialPhoto,
      lookingForLabels,
      educationLabels,
      ethnicityLabels,
      bodyTypeLabels,
      relationshipLabels,
      lifestyleExpectationLabels
    } = this.state;
    const { ucdUser } = this.props;
    const isFavourited = ucdUser.hasFavourited.includes(user.id);
    const profilePhoto =
      user.photos.length > 0
        ? user.photos.filter(el => el.profile === 1).pop()
        : { thumbnail: "" };
    const otherPhotos = user.photos.filter(el => el.profile === 0);
    const primaryLocation =
      user.locations.length > 0
        ? user.locations.filter(el => el.primary === 1).pop()
        : { country: "NL" };
    return (
      <div className="container-fluid public-profile">
        <div className="container">
          <div className="row">
            {window.outerHeight > 768 && (
              <div className="col col-md-3 d-none d-md-block side">
                <div
                  className="photo"
                  style={{
                    backgroundImage: `url('${profilePhoto.thumbnail}')`
                  }}
                  onClick={() => {
                    this.handleGalleryModalOpen(0);
                  }}
                >
                  {user.employee === 1 && <img src={logo} alt="Employee" />}
                </div>
                <div className="info">
                  <div className="info-item">
                    <img src={clock} alt="clock" />
                    <div className="label">Member since</div>
                    <div className="value">
                      {moment(user.created_at).format("MMM D, YYYY")}
                    </div>
                  </div>
                  <div className="info-item">
                    <img src={location} alt="location" />
                    <div className="label">Location</div>
                    <div className="value">
                      {fullCountryName(primaryLocation.country)}
                    </div>
                  </div>
                  <div className="info-item">
                    <img src={clock} alt="clock" />
                    <div className="label">Last active</div>
                    <div className="value">
                      {user.last_active !== null &&
                      moment().subtract(user.last_active, "days") <= 5
                        ? moment(user.last_active).format("MMM D, YYYY")
                        : this.fakeLastActiveDate(user)}
                    </div>
                  </div>
                  <div className="info-item">
                    <img src={location} alt="location" />
                    <div className="label">Location</div>
                    <div className="value">
                      {fullCountryName(primaryLocation.country)}
                    </div>
                  </div>
                  {user.accountType === "sugar_baby" &&
                    user.refCode.length > 0 &&
                    user.refCode !== "disabled" &&
                    user.refCode !== "pending" && (
                      <div className="info-item">
                        <img src={star} alt="star" />
                        <div className="label">Reference code:</div>
                        <div className="value">{user.refCode}</div>
                      </div>
                    )}
                </div>
                {ucdUser && ucdUser.status <= 3 && (
                  <div className="d-md-block ad-container">
                    {/* <GoogleAd
                      client="ca-pub-2888386750549640"
                      slot="6870801970"
                      format="auto"
                    /> */}
                  </div>
                )}
              </div>
            )}
            <div className="col col-md-9 main-column">
              <div
                className="intro"
                onClick={e => {
                  this.handleGalleryModalOpen(0, e);
                }}
                style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.4)), url('${
                    profilePhoto.thumbnail
                  }')`
                }}
              >
                {user.employee === 1 && (
                  <img
                    src={logo}
                    className="d-inline-block d-md-none"
                    alt="Employee"
                  />
                )}
                <div className="texts">
                  <div className="name">{user.name}</div>
                  <div className="info">
                    {moment().diff(
                      moment(user.birthDate, "YYYY-MM-DD"),
                      "years"
                    )}{" "}
                    &bull; {user.sex === "F" ? "Female" : "Male"} &bull;{" "}
                    {`${primaryLocation.city}, ${fullCountryName(
                      primaryLocation.country
                    )}`}
                  </div>
                  <div className="headline">
                    <div>{user.headline}</div>
                    {ucdUser !== null &&
                      ucdUser.status >= USER_STATUSES.approved && (
                        <div className="buttons">
                          <button
                            className="btn message d-none d-md-inline-block"
                            onClick={() => {
                              this.createRoom(user.id);
                            }}
                          >
                            <img src={message} alt={"message"} />
                            Message
                          </button>
                          <button
                            className={"btn d-none d-md-inline-block"}
                            onClick={() => {
                              this.toggleFavourite(user.name, !isFavourited);
                            }}
                          >
                            <img
                              src={isFavourited ? heartSolidRed : heartSolid}
                              alt={"heart"}
                            />
                          </button>
                          <button
                            className={"btn d-none d-md-inline-block"}
                            onClick={() => {
                              this.toggleUserPopup();
                            }}
                          >
                            <img src={userIcon} alt={"user"} />
                          </button>
                          <div
                            className={`hide-member ${
                              showUserSubMenu ? "show" : ""
                            }`}
                            onClick={() => {
                              this.toggleBlock(
                                user.name,
                                !ucdUser.hasBlocked.includes(user.id)
                              );
                            }}
                          >
                            {`${
                              !ucdUser.hasBlocked.includes(user.id)
                                ? "Hide"
                                : "Show"
                            } member`}
                            <img src={chevron} alt={"chevron"} />
                          </div>
                          <div
                            className={`hide-member second ${
                              showUserSubMenu ? "show" : ""
                            }`}
                            onClick={() => {
                              this.setState({ isModalOpen: true });
                            }}
                          >
                            {`Report member`}
                            <img src={chevron} alt={"chevron"} />
                          </div>
                        </div>
                      )}
                  </div>
                  {user.refCode &&
                    user.refCode.length > 0 &&
                    user.refCode !== "disabled" &&
                    user.refCode !== "pending" && (
                      <div className="host">
                        <img src={mask} alt={"mask"} />
                        <span>Host</span>
                      </div>
                    )}
                  {user.status >= USER_STATUSES.superior && (
                    <div className="superior">
                      <img src={diamond} alt={"diamond"} />
                      SUPERIOR
                    </div>
                  )}
                </div>
              </div>
              {user.status < USER_STATUSES.approved && (
                <FullWidthInfo>
                  Sorry, your profile is not visible yet. We suggest to change
                  your profile image. Check our{" "}
                  <a
                    href="https://upperclassdates.com/photo-guidelines/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    photo guidelines
                  </a>{" "}
                  for more information.
                </FullWidthInfo>
              )}
              {user.photos.length > 1 && (
                <Slider
                  className="slider"
                  perSlide={4}
                  responsive={[
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        infinite: true
                      }
                    }
                  ]}
                >
                  {otherPhotos.map((photo, i) => {
                    return (
                      <div
                        key={Math.random()}
                        className="photo"
                        onClick={() => {
                          this.handleGalleryModalOpen(i + 1);
                        }}
                        style={{ backgroundImage: `url('${photo.thumbnail}')` }}
                      />
                    );
                  })}
                </Slider>
              )}
              <div className="info">
                <div className="info-item">
                  <img src={clock} alt="clock" />
                  <div className="label">Member since</div>
                  <div className="value">
                    {moment(user.created_at).format("MMM D, YYYY")}
                  </div>
                </div>
                <div className="info-item">
                  <img src={clock} alt="clock" />
                  <div className="label">Last active</div>
                  <div className="value">
                    {user.last_active !== null &&
                    moment().subtract(user.last_active, "days") <= 5
                      ? moment(user.last_active).format("MMM D, YYYY")
                      : this.fakeLastActiveDate(user)}
                  </div>
                </div>
                <div className="info-item">
                  <img src={location} alt="location" />
                  <div className="label">Location</div>
                  <div className="value">
                    {fullCountryName(primaryLocation.country)}
                  </div>
                </div>
                {user.accountType === "sugar_baby" &&
                  user.refCode.length > 0 &&
                  user.refCode !== "disabled" &&
                  user.refCode !== "pending" && (
                    <div className="info-item">
                      <img src={star} alt="star" />
                      <div className="label">Reference code:</div>
                      <div className="value">{user.refCode}</div>
                    </div>
                  )}
                {ucdUser !== null && ucdUser.status >= USER_STATUSES.approved && (
                  <div
                    className={`hide-member d-block d-md-none`}
                    onClick={() => {
                      this.toggleBlock(
                        user.name,
                        !ucdUser.hasBlocked.includes(user.id)
                      );
                    }}
                  >
                    {`${
                      !ucdUser.hasBlocked.includes(user.id) ? "Hide" : "Show"
                    } member`}
                    <img src={chevron} alt={"chevron"} />
                  </div>
                )}
              </div>
              <div className="preferences">
                <div className="title">{`${user.name}'s info`}</div>
                <div className="info">
                  <div className="info-item">
                    <div className="label">Looking for</div>
                    <div className="value">
                      {lookingForLabels[user.lookingFor]}
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="label">Ethnicity</div>
                    <div className="value">
                      {ethnicityLabels[user.ethnicity]}
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="label">
                      Lifestyle{" "}
                      {user.accountType === "sugar_baby"
                        ? "expectations"
                        : "budget"}
                    </div>
                    <div className="value">
                      {lifestyleExpectationLabels[user.lifestyleExpectations]}
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="label">Education</div>
                    <div className="value">
                      {educationLabels[user.education]}
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="label">Body type</div>
                    <div className="value">{bodyTypeLabels[user.bodyType]}</div>
                  </div>
                  <div className="info-item">
                    <div className="label">Occupation</div>
                    <div className="value">{user.occupation}</div>
                  </div>
                  <div className="info-item">
                    <div className="label">Height</div>
                    <div className="value">{`${user.height} cm`}</div>
                  </div>
                  <div className="info-item">
                    <div className="label">Relationship</div>
                    <div className="value">
                      {relationshipLabels[user.relationship]}
                    </div>
                  </div>
                </div>
              </div>
              <div className="texts">
                <div className="title">About me</div>
                <div className="text">{user.aboutMe}</div>
                <div className="title">Looking For</div>
                <div className="text">{user.lookingForText}</div>
              </div>
            </div>
          </div>
        </div>
        {ucdUser !== null && ucdUser.status >= USER_STATUSES.approved && (
          <div className="bottom-link">
            <button className="btn" onClick={() => this.createRoom(user.id)}>
              go chat
            </button>
            <button
              className={"btn favourite"}
              onClick={e => this.toggleFavourite(user.name, !isFavourited)}
            >
              <img
                src={isFavourited ? heartSolidRed : heartSolid}
                alt={"heart"}
              />
            </button>
          </div>
        )}
        {user.photos.length > 0 && (
          <PhotoSwipe
            isOpen={galleryModalOpen}
            items={user.photos}
            options={{
              bgOpacity: 0.7,
              shareEl: false,
              index: modalInitialPhoto
            }}
            onClose={() => {
              this.setState({ galleryModalOpen: false });
            }}
          />
        )}
        <Modal
          isOpen={isModalOpen}
          ariaHideApp={false}
          onRequestClose={() => {
            this.closeModal();
          }}
          contentLabel="Example Modal"
          style={{
            content: {
              top: "50%",
              bottom: "auto",
              left: "50%",
              right: "auto",
              transform: "translate(-50%, -50%)"
            }
          }}
        >
          {successReport && (
            <div className="content text-center">
              <div className="message">{reportMessage}</div>
              <button
                onClick={() => {
                  this.setState({ isModalOpen: false });
                }}
              >
                {" "}
                Close X
              </button>
            </div>
          )}
          {!successReport && (
            <div className="content text-center">
              <div className="message">Report User</div>
              <div className="field-container select dob open">
                <div className="field-title">Reason:</div>
                <div className="row">
                  <div className="col">
                    <Select
                      options={[
                        {
                          value: "abuse",
                          label: "Abuse"
                        },
                        {
                          value: "other",
                          label: "Other"
                        }
                      ]}
                      onChange={value => {
                        this.setState({ reason: value.value });
                      }}
                      value={reason}
                      clearable={false}
                    />
                  </div>
                </div>
              </div>
              {reason === "other" && (
                <div className="field-container text open">
                  <div className="field-title">
                    Why do you want to report this user?:
                  </div>
                  <div className="row">
                    <div className="col">
                      <textarea
                        rows="4"
                        onChange={e =>
                          this.setState({ reasonText: e.target.value })
                        }
                        type="text"
                        name="aboutMe"
                        placeholder="Why are you reporting this user."
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="row button-container space-between justify-content-center">
                <button
                  className="btn btn-primary submit"
                  onClick={e => this.submitReport()}
                >
                  Submit
                </button>
              </div>
              <button
                onClick={() => {
                  this.setState({ isModalOpen: false });
                }}
              >
                {" "}
                Close X
              </button>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  ucdUser: state.sessionState.ucdUser
});

const mapDispatchToProps = dispatch => ({
  onChatRoomSelected: (openRoom, user) =>
    dispatch({
      type: "SET_OPEN_ROOM",
      openRoom,
      openChatDrawer: openRoom !== false,
      user
    }),
  onSetAuthUser: (authUser, ucdUser) =>
    dispatch({ type: "AUTH_USER_SET", authUser, ucdUser })
});

const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(publicProfile);



// WEBPACK FOOTER //
// ./src/pages/publicProfile.js